import { Pipe, PipeTransform } from '@angular/core';
import { AccountAttributesEnum } from '../enums';
import { UserService } from '../../core/services/user.service';

@Pipe({
    name: 'isExportAllDisabled'
})
export class isExportAllDisabledPipe implements PipeTransform {
    constructor(private userService: UserService) {}

    transform(exportTypes: AccountAttributesEnum[]): boolean {
        return exportTypes.every((eType: AccountAttributesEnum) => !this.userService.hasAccess(eType));;
    }
}
